// extracted by mini-css-extract-plugin
export default {"propertyList":"property-list_propertyList__R1uMU","content":"property-list_content__c47JA"};